module.exports = __webpack_public_path__ + "media/images/temp/ribbon-5-eb2256ff0938f1f8ce9975183904858f.png";